import React from 'react'
import { Box, Typography, TextField, ToggleButton, ToggleButtonGroup, Stack, InputAdornment } from '@mui/material'

/**
 * Input numérico con toggle selector a la derecha.
 * Ejemplo: campo DAP/CAP con toggle para elegir tipo.
 */
const ToggleField = ({
  label,
  value,
  onChange,
  toggleOptions = [],
  selectedToggle,
  onToggleChange,
  placeholder = '0.00',
  icon: Icon,
  unit = '',
}) => {
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={0.5} mb={1}>
        {Icon && <Icon sx={{ fontSize: 20, color: 'primary.main' }} />}
        <Typography variant="body2" fontWeight={500}>{label}</Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="stretch">
        <TextField
          type="number"
          inputMode="decimal"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          size="small"
          fullWidth
          InputProps={{
            ...(unit && {
              endAdornment: <InputAdornment position="end">{unit}</InputAdornment>,
            }),
            sx: { height: 48, fontSize: '1rem' },
          }}
          sx={{ flex: 1 }}
        />
        <ToggleButtonGroup
          value={selectedToggle}
          exclusive
          onChange={(_, val) => { if (val !== null) onToggleChange(val) }}
          size="small"
          sx={{
            '& .MuiToggleButton-root': {
              px: 2,
              height: 48,
              fontWeight: 600,
              fontSize: '0.85rem',
              textTransform: 'none',
            },
            '& .Mui-selected': {
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              '&:hover': { bgcolor: 'primary.dark' },
            },
          }}
        >
          {toggleOptions.map((opt) => (
            <ToggleButton key={opt.value} value={opt.value}>
              {opt.label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Stack>
    </Box>
  )
}

export default ToggleField
